import {
  GET_USER,
  GET_USERVIDEOS,
  GET_NOTES,
  GET_BOOKMARKS,
  CLEAR_USER,
  FILTER_VIDEOS,
  CLEAR_FILTER,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case GET_USER:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case GET_USERVIDEOS:
      return {
        ...state,
        loading: false,
        videos: action.payload,
      };
    case GET_NOTES:
      return {
        ...state,

        loading: false,
        notes: action.payload,
      };
    case CLEAR_USER:
      return { ...state, loading: true, notes: null, videos: null, user: null };
    case FILTER_VIDEOS:
      if (action.payload.type === "videos") {
        return {
          ...state,
          filter: state.videos.filter((vid) => {
            const keyword = RegExp(`${action.payload.text}`, "gi");
            return vid.name.match(keyword);
          }),
        };
      } else {
        return {
          ...state,
          filter: state.notes.filter((vid) => {
            const keyword = RegExp(`${action.payload.text}`, "gi");
            return vid.name.match(keyword);
          }),
        };
      }

    case CLEAR_FILTER:
      return {
        ...state,
        filter: null,
      };
    default:
      return state;
  }
};
